import { Skeleton, Space } from 'antd';
import React from 'react';

export const UserDetailsSkeleton = () => (
  <Space align="baseline">
    <Skeleton.Avatar size="large" />
    <Space size={0} direction="vertical">
      <Skeleton.Input size="small" style={{ width: 125, height: 12 }} />
      <Skeleton.Input size="small" style={{ width: 100, height: 12 }} />
    </Space>
  </Space>
);
